// Created by Abhijit for Full page web wnquiry form
import { upDownNumberInput } from "../up-down-number-input";
import FieldValidator from "../field-validator/FieldValidator";
import Loader from "../loading/loader";
import { GATracking } from "../../utils/webtracking";
import 'regenerator-runtime/runtime';

class PlanYourTripFormFullPage {
    constructor(DOMelement) {
        try {
            this.el = DOMelement;
            var stickyHeaderSection = document.getElementsByClassName("sd-toolbar")[0];
            stickyHeaderSection.classList.add("sticky-header-hidden-mobile");

            this.form = this.el.querySelector(".pyt__form");
            
            this.loaderEl = this.el.querySelector(".sd-loading");
            this.loader = new Loader(this.loaderEl);

            this.checkValidity = this.checkValidity.bind(this);
            this.onPhoneSelectorChange = this.onPhoneSelectorChange.bind(this);
            this.cleanHtml = this.cleanHtml.bind(this);

            // add initial event listener to the form inputs
            this.countrySelector = this.form.querySelector('[name="CountryCode"]');

            //recapcha
            this.reCaptchaSiteKey = this.form.getAttribute("data-site-key");
            this.reCpatchaTokenInput = this.form.querySelector('[id="RecapchaToken"]');
            this.populateRecapchaToken = this.populateRecapchaToken.bind(this);

            // up-down-number
            this.guestsFieldset = document.querySelectorAll(".sd-up-down-number-input__input");
            this.adults = this.form.querySelector('[name="Adult"]');
            this.children = this.form.querySelector('[name="Children"]');

            // Phone selector
            this.phoneSelector = this.el.querySelector(".phone-selector");
            this.phoneInput = this.el.querySelector(".sd-phone-number-input__label");

            //budget text
            this.budgetSelector = this.el.querySelector('[name="Budget"]');
            this.budgetText = this.el.querySelector(".budgetText");
            this.budgetDisplay = this.el.querySelector('input[name="DisplayBudget"]').value;

            //user time zone
            this.form.querySelector('[name="TimeZone"]').value = new Date();

            // Pages
            this.form_container = this.form.querySelector("#plan-your-trip-form-full-page-wrapper");

            // Fieldsets
            this.fieldSetsOne = this.form_container.querySelectorAll(".sd-fieldset");

            // onChange event
            this.fieldSetInputs = this.form.querySelectorAll(".sd-fieldset__input");
            this.onEventChange = this.onEventChange.bind(this);
            this.onEventChange();

            //submit button
            this.submitButton = this.form.querySelector(".sd-plan-your-trip__next-button");
            this.inputsValidators = this.form.querySelectorAll("input");
            this.selectValidators = this.form.querySelectorAll("select");

            document.querySelectorAll('.increment')[0].onclick = function () {
                sessionStorage.setItem("adultsStored", (Number(this.form.querySelector('[id="up-down-adults"]').value) + 1));
            }

            document.querySelectorAll('.decrement')[0].onclick = function () {
                sessionStorage.setItem("adultsStored", (Number(this.form.querySelector('[id="up-down-adults"]').value) - 1));
            }

            document.querySelectorAll('.increment')[1].onclick = function () {
                sessionStorage.setItem("childStored", (Number(this.form.querySelector('[id="up-down-children"]').value) + 1));
            }

            document.querySelectorAll('.decrement')[1].onclick = function () {
                sessionStorage.setItem("childStored", (Number(this.form.querySelector('[id="up-down-children"]').value) - 1));
            }

            if(this.budgetDisplay === "True") {
                let budgetField = this.form.querySelector('[name="Budget"]'),
                        options = budgetField.querySelectorAll("option"),
                        optionsValue = [];

                if (sessionStorage.getItem("budgetListStored")) {                
                    const budgetValue = sanitizeHTML(sessionStorage.getItem("budgetListStored"));
                    
                    options.forEach((el) => {
                        optionsValue.push(el.value);
                    });
                    
                    if(optionsValue.includes(budgetValue)) budgetField.value = budgetValue;
                }
            
                if (sessionStorage.getItem("budgetTextStored")) {
                    const budgetTextValue = sanitizeHTML(sessionStorage.getItem("budgetTextStored")); 
                    this.form.querySelector('[name="BudgetText"]').value = budgetTextValue;
                } else {
                    this.form.querySelector('[name="BudgetText"]').value = options[budgetField.selectedIndex].text;
                }
            }
           
            if (sessionStorage.getItem("optionListStored")) {
                const optionValue = sanitizeHTML(sessionStorage.getItem("optionListStored"));
                this.form.querySelector("[name='option-list']").value = optionValue;
            }
            if (sessionStorage.getItem("bestTimeStored")) {
                const optionValue1 = sanitizeHTML(sessionStorage.getItem("bestTimeStored"));
                this.form.querySelector("[name='best-time-to-call']").value = optionValue1;
            }

            if (sessionStorage.getItem("DisplayOptOutStored")) {
                const DisplayOptOutValue = sanitizeHTML(sessionStorage.getItem("DisplayOptOutStored"));
                this.form.querySelector("[name='DisplayOptOut']").checked = DisplayOptOutValue;
            }

            if (sessionStorage.getItem("monthStored")) {
                const monthValue = sanitizeHTML(sessionStorage.getItem("monthStored"));
                this.form.querySelector("[name='Month']").value = monthValue;
            }

            if (sessionStorage.getItem("yearStored")) {
                const yearValue = sanitizeHTML(sessionStorage.getItem("yearStored"));
                this.form.querySelector("[name='Year']").value = yearValue;
            }

            if (sessionStorage.getItem("adultsStored")) {
                const adultsValue = sanitizeHTML(sessionStorage.getItem("adultsStored"));
                this.form.querySelector("[id='up-down-adults']").value = adultsValue;
            } else {
                this.form.querySelector("[id='up-down-adults']").value = 2;
            }

            if (sessionStorage.getItem("childStored")) {
                const childrenValue = sanitizeHTML(sessionStorage.getItem("childStored"));
                this.form.querySelector("[id='up-down-children']").value = childrenValue;
            } else {
                this.form.querySelector("[id='up-down-children']").value = 0;
            }

            if(sessionStorage.getItem("commentStored")){
                const commentValue = sessionStorage.getItem("commentStored");
                this.form.querySelector("[name='Comment']").value = commentValue;
            }

            const firstNameValue = sanitizeHTML(sessionStorage.getItem("firstNameStored"));
            this.form.querySelector("[name='firstName']").value = firstNameValue;

            const lastNameValue = sanitizeHTML(sessionStorage.getItem("lastNameStored"));
            this.form.querySelector("[name='lastName']").value = lastNameValue;

            const phoneNumberValue = sanitizeHTML(sessionStorage.getItem("phoneNumberStored"));
            this.form.querySelector(".sd-phone-number-input__input").value = phoneNumberValue;

            if (sessionStorage.getItem("CountryGuidCodeStored")) {
                const countryCodeValue = sanitizeHTML(sessionStorage.getItem("countryCodeStored"));
                for (var i = 0; this.countrySelector.length > i; i++) {
                    if (this.countrySelector[i].value == sanitizeHTML(sessionStorage.getItem("CountryGuidCodeStored"))) {
                        this.countrySelector.value = this.countrySelector[i].value;
                    }
                }
                this.form.querySelector(".sd-phone-number-input__label").textContent = countryCodeValue;
            }

            const emailValue = sanitizeHTML(sessionStorage.getItem("emailStored"));
            this.form.querySelector("[name='email']").value = emailValue;

            function sanitizeHTML(input) {
                const div = document.createElement('div');
                div.innerText = input;
                return div.innerHTML;
            }

            if (this.submitButton) {
                this.submitButton.addEventListener("click", (event) => {
                    this.checkValidity(this.fieldSetsOne);
                    this.scrollToContactForm();
                    this.validationDynamicFlag = true;
                })
            }
            // inputsValidators
            if (this.inputsValidators) {
                this.inputsValidators.forEach((inputsValidator, index) => {
                    inputsValidator.addEventListener("keyup", () => {
                        this.checkValidityDynamic(this.fieldSetsOne);
                    })
                })
            }

            // selectValidators
            if (this.selectValidators) {
                this.selectValidators.forEach((selectValidator, index) => {
                    selectValidator.addEventListener("click", () => {
                        this.checkValidityDynamic(this.fieldSetsOne);
                    })
                })
            }

            this.phoneSelector.addEventListener("change", (event) =>
                this.onPhoneSelectorChange(event.target.options)
            );
            // Init counters
            upDownNumberInput.init();

            // for contact-us-page
            this.queryString = new URLSearchParams(window.location.search);
            if (this.queryString) {
                this.queryStringValue = Object.fromEntries(this.queryString.entries());
            }

            if (Object.keys(this.queryStringValue).length !== 0) {
                this.selectedMonth = this.queryStringValue.m;
                this.selectedPrice = this.queryStringValue.p;
            }

            const date = new Date();
            const currMonth = date.getMonth() + 1;
            const currYear = date.getFullYear();
            const monthFields = [...this.fieldSetInputs].filter(field => field.name === "Month");
            const yearFields = [...this.fieldSetInputs].filter(field => field.name === "Year");
            const yearOptionList = yearFields[0].querySelectorAll("option");

            yearOptionList.forEach(yearOption => {
                if ((yearOption.value < currYear) || (this.selectedMonth && currMonth > this.selectedMonth && yearOption.value == currYear)) {
                    yearOption.disabled = false;
                }
            })

            if (this.selectedMonth && this.selectedPrice) {
                monthFields[0].value = this.selectedMonth;
                yearFields[0].value = this.selectedMonth < currMonth ? currYear + 1 : currYear;               
            }

            monthFields[0].addEventListener("change", () => {
                yearOptionList.forEach(yearOption => {
                    if (monthFields[0].value < currMonth && yearFields[0].value == currYear) {
                        this.stopSelectingPreviousMonth();
                    }
                    if (yearOption.value == currYear) {
                        monthFields[0].value < currMonth ? yearOption.disabled = true : yearOption.disabled = false;
                    }
                })
            })

        } catch (error) {
            console.log(error);
        }
        console.debug('PYT Form elements loaded and processed')
    }

    async populateRecapchaToken() {
        var recaptcha_token = '';
        grecaptcha.ready(() => {
            grecaptcha.execute(this.reCaptchaSiteKey, { action: 'submit' })
                .then((token) => {
                    recaptcha_token = token;
                })
                .catch((error) => {
                    console.log(error);
                });
        });
        while (recaptcha_token == '') {
            await new Promise(r => setTimeout(r, 500));
        }
        console.log("recapcha token: " + recaptcha_token);
        this.reCpatchaTokenInput.value = recaptcha_token;
        this.form.submit();
    }

    stopSelectingPreviousMonth = () => {
        const yearFields = [...this.fieldSetInputs].filter(field => field.name === "Year");
        yearFields[0].value = "";
    }

    //store value in session any text fields / select
    onEventChange() {
        this.fieldSetInputs.forEach((fieldEle, index) => {
            fieldEle && fieldEle.addEventListener("change", () => {

                if (fieldEle.name === "option-list") sessionStorage.setItem("optionListStored", fieldEle.selectedOptions[0].innerText);
                if (fieldEle.name === "best-time-to-call") sessionStorage.setItem("bestTimeStored", fieldEle.selectedOptions[0].value);
                if (fieldEle.name === "Month") sessionStorage.setItem("monthStored", fieldEle.selectedOptions[0].value);
                if (fieldEle.name === "Year") sessionStorage.setItem("yearStored", fieldEle.selectedOptions[0].value);
                if (fieldEle.name === "DisplayOptOut") sessionStorage.setItem("DisplayOptOutStored", fieldEle.checked);
                if (fieldEle.name === "CountryCode") sessionStorage.setItem("CountryGuidCodeStored", fieldEle.selectedOptions[0].value);
                if (fieldEle.id === "up-down-adults") sessionStorage.setItem("adultsStored", (Number(this.form.querySelector('[id="up-down-adults"]').value)));
                if (fieldEle.id === "up-down-children") sessionStorage.setItem("childStored", (Number(this.form.querySelector('[id="up-down-children"]').value)));
                if (fieldEle.name === "firstName") sessionStorage.setItem("firstNameStored", this.form.querySelector('[name="firstName"]').value);
                if (fieldEle.name === "lastName") sessionStorage.setItem("lastNameStored", this.form.querySelector('[name="lastName"]').value);
                if (fieldEle.name === "email") sessionStorage.setItem("emailStored", this.form.querySelector('[name="email"]').value);

                if (fieldEle.name === "Budget") {
                    this.form.querySelector(".budgetText").value = fieldEle.selectedOptions[0].innerText;
                    sessionStorage.setItem("budgetListStored", fieldEle.selectedOptions[0].value);
                    sessionStorage.setItem("budgetTextStored", fieldEle.selectedOptions[0].innerText);
                }

                if (fieldEle.name === "CountryCode") sessionStorage.setItem("countryCodeStored", ("+" + fieldEle.selectedOptions[0].innerHTML.replace(/[^0-9]/g, '')));

                if (fieldEle.name === "Phone") {
                    const str = this.form.querySelector(".sd-phone-number-input__input").value;
                    this.form.querySelector(".sd-phone-number-input__input").value = str.replace(/[^0-9]/g, '');
                    sessionStorage.setItem("phoneNumberStored", this.form.querySelector(".sd-phone-number-input__input").value);
                }

                if (fieldEle.name === "Comment") {
                    this.cleanHtml();
                    sessionStorage.setItem("commentStored", this.form.querySelector(".text-area textarea").value);
                }
            })
        })
    }

    cleanHtml(e) {
        const strg = this.form.querySelector(".text-area textarea").value;
        this.form.querySelector(".text-area textarea").value = strg.replace(/(<([^>]+)>)/ig, '');
    }

    submitForm() {
        document.getElementsByClassName("full-page-form-submit")[0].style.fontSize = "0px";

        this.submitButton = false;
        if (this.loader) {
            this.loader.show();
        }
        document.getElementById("full-page-overlay").style.display = "block";

        this.adults.value = Number(this.guestsFieldset[0].value);

        this.children.value = Number(this.guestsFieldset[1].value);

        GATracking.formValidation('form_submission', 'plan your trip', 'success');

        this.populateRecapchaToken();
    }

    onPhoneSelectorChange(options) {
        const code = options[options.selectedIndex].getAttribute("data-code");
        this.phoneInput.innerHTML = code;
    }

    scrollToContactForm() {
        if (document.getElementsByClassName('sd-input--error')[0]) {
            window.scrollTo(0, (window.scrollY + document.getElementsByClassName('sd-input--error')[0].getBoundingClientRect().top - 130));
        }
    }

    checkValidity(fieldSets) {
        if (this.loader) {
            this.loader.show();
        }
        const validatedFieldSets = [...fieldSets]
            .filter(item => {
                const checkbox = item.querySelector(".sd-fieldset__checkbox-check");
                // Exclude fieldsets containing checkboxes from validation
                if (checkbox) {
                    return false;
                }
                return item.querySelector(".sd-fieldset__item").style.display === "none" ? false : item;
            })
            .map(form => {
                let result = new FieldValidator(form).validate();
                if (this.loader) {
                    this.loader.hide();
                }
                return result;
            });
        if (validatedFieldSets.every((isValid) => !!isValid)) {
            GATracking.formValidation('error_tracking', 'plan your trip', 'success');
            this.submitForm();
        } else {
            GATracking.formValidation('error_tracking', 'plan your trip', 'fail');
        }
    }

    checkValidityDynamic(fieldSets) {
        if (this.validationDynamicFlag == true) {
            const validatedFieldSets = [...fieldSets]
                .filter(item => item.querySelector(".sd-fieldset__item").style.display === "none" ? false : item)
                .map(form => {
                    let result = new FieldValidator(form).validate();
                    if (this.loader) {
                        this.loader.hide();
                    }
                    return result;
                });
        }
    }
}

export default PlanYourTripFormFullPage;